import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

function SobreMi() {
  return (
    <div className="page about-page">
      <Seo
        title="Sobre mí"
        description="Soy la persona detrás de Libros para Viajeros: libros, lugares e historias que merece la pena descubrir."
      />
      <header className="about-hero">
        <span className="eyebrow">Detrás de las páginas</span>
        <h1>Sobre mí</h1>
        <p>
          Soy la persona detrás de Libros para Viajeros, un proyecto que nació de dos de mis grandes pasiones:
          leer y descubrir lugares.
        </p>
      </header>

      <div className="about-layout">
        <aside className="about-quote" aria-label="Filosofía de Libros para Viajeros">
          <span aria-hidden="true">“</span>
          <p>Los libros siempre han sido para mí una forma de viajar incluso sin moverme de casa.</p>
        </aside>

        <article className="about-story">
          <p>
            Me gusta perderme en historias, conocer personajes que se quedan conmigo y descubrir lugares que,
            muchas veces, terminan despertándome las ganas de visitarlos en la vida real.
          </p>
          <p>
            En Libros para Viajeros comparto mis lecturas de una forma cercana y personal: reseñas, recomendaciones,
            libros que me sorprenden, otros que no terminan de conquistarme y todas esas historias que creo que merece
            la pena descubrir. Aquí no encontrarás opiniones condicionadas: intento contar siempre qué me ha hecho
            sentir realmente cada lectura.
          </p>
          <p>
            Con el tiempo, el proyecto ha ido creciendo más allá de los libros. También comparto librerías, ferias,
            viajes, rutas y lugares relacionados con la literatura, porque creo que algunas historias no terminan
            cuando cerramos un libro.
          </p>

          <hr className="rule" />

          <p>
            Además de esta web, creo contenido literario en{' '}
            <a href="https://www.instagram.com/librosparaviajeros/" target="_blank" rel="noreferrer">Instagram</a> y
            desarrollo <Link to="/podcast">Entre Páginas</Link>, mi podcast, donde sigo hablando de libros, autores,
            curiosidades y todo lo que rodea al mundo de la lectura.
          </p>
          <p>
            Actualmente también colaboro con editoriales, escritores y proyectos relacionados con la cultura y la
            literatura, creando reseñas y contenido editorial y audiovisual para acercar nuevas historias a los
            lectores.
          </p>
        </article>
      </div>

      <footer className="about-closing">
        <p>
          Libros para Viajeros es, en definitiva, mi rincón para hablar de libros, descubrir lugares y compartir
          historias que merecen seguir viajando.
        </p>
        <Link className="text-link" to="/trabaja-conmigo">Conoce mi trabajo profesional <span aria-hidden="true">→</span></Link>
      </footer>
    </div>
  );
}

export default SobreMi;
